import React, { useState, useEffect } from "react";
import styles from "../../styles/emissionActivity.module.css";
import { observer } from "mobx-react";
import loadingSvg from "../../../Assets/images/tube-spinner.svg";
import emissionViewStore from "../../../Store/marco/emissionViewStore";
import commonStore from "../../../Store/marco/commonStore";
import { useTranslation } from "react-i18next";
export const EmissionActivityExcelModal = observer(() => {
  const store = emissionViewStore;
  const cmStore = commonStore;
  const { t } = useTranslation("ActivityMain");
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(t("Choose a file (.xlsx)"));
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleDownload = async () => {
    store.downloadEAExcel(cmStore.lang);
  };

  const handleUpload = async () => {
    // 使用語系設定 lang（而非 land）
    store.uploadEAExcel(cmStore.lang, file);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw", // 讓背景覆蓋整個視窗
        height: "100vh",
        background: "rgba(0, 0, 0, 0.5)", // 半透明背景
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          width: "800px",
          height: "300px",
          position: "relative",
        }}
      >
        {emissionViewStore.emissionActivityModalLoading === true ? (
          <div className={styles.loading} style={{ top: "0" }}>
            <img
              className={styles.loadingImg}
              src={loadingSvg}
              alt="loadingSvg"
            />
          </div>
        ) : null}

        <h3
          style={{
            textAlign: "left",
            color: "black",
            paddingLeft: "15px",
            paddingTop: "20px",
            height: "80px",
            margin: "0",
            width: "100%",
            borderBottom: "1px solid #ccc",
          }}
        >
          {t("Excel Import and Export")}
          <div
            style={{
              float: "right",
              width: "185px",
              height: "43px",
              fontSize: "16px",
              backgroundColor: "rgb(40,60,130)",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "400",
              marginRight: "20px",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={handleDownload}
          >
            {t("Export")}
          </div>
        </h3>
        <main
          style={{
            textAlign: "left",
            color: "black",
            paddingLeft: "15px",
            height: "150px",
            borderBottom: "1px solid #ccc",
          }}
        >
          <div
            style={{
              paddingTop: "15px",
              marginBottom: "10px",
            }}
          >
            {t("New File Upload")}
          </div>
          <div style={{ display: "flex", fontFamily: "Arial, sans-serif" }}>
            <div style={{ display: "block", fontFamily: "Arial, sans-serif" }}>
              <input
                type="file"
                id="fileInput"
                accept=".xlsx"
                style={{ display: "none" }}
                onChange={(e) => {
                  handleFileChange(e);
                }}
              />
              <label
                htmlFor="fileInput"
                style={{
                  display: "inline-block",
                  padding: "10px 15px",
                  border: "1px solid #d1d3e2",
                  borderRadius: "5px",
                  backgroundColor: "#ffffff",
                  color: "#6c757d",
                  fontSize: "16px",
                  cursor: "pointer",
                  width: "500px",
                  height: "45px",
                  textAlign: "left",
                }}
              >
                {fileName}
              </label>
            </div>
            <button
              style={{
                width: "185px",
                height: "43px",
                fontSize: "16px",
                backgroundColor: file ? "rgb(40,60,130)" : "rgb(118,128,176)",
                color: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "400",
                marginLeft: "60px",
                borderRadius: "5px",
                cursor: file ? "pointer" : "not-allowed",
              }}
              disabled={!file}
              onClick={handleUpload}
            >
              {t("Import")}
            </button>
          </div>
        </main>
        <div
          style={{
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
            height: "70px",
            borderBottom: "1px solid #ccc",
          }}
        >
          <button
            style={{
              width: "70px",
              height: "40px",
              backgroundColor: "rgb(136,136,136)",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "30px",
            }}
            onClick={() => {
              store._handleSetIsShowEmissionActivityExcelModal(false);
            }}
          >
            {t("Close")}
          </button>
        </div>
      </div>
    </div>
  );
});
